mutation rejectAssignmentProposal(
  $scenarioId: ID!
  $originId: ID!
  $linkId: ID!
  $proposalId: ID!
  $reason: String!
) {
  cube(scenarioId: $scenarioId, originId: $originId) {
    rejectAssignmentProposal(linkId: $linkId, proposalId: $proposalId, reason: $reason) {
      errorCode
      proposalId
      state
      status
      __typename
    }
    __typename
  }
}
